document.addEventListener('DOMContentLoaded', function () {
  // Menu déroulant catégorie (clavier + tactile)
  document.querySelectorAll('[data-dropdown]').forEach(function (d) {
    var t = d.querySelector('[data-dropdown-toggle]');
    if (!t) return;
    t.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches || d.classList.contains('is-open')) {
        e.preventDefault();
      }
      d.classList.toggle('is-open');
    });
    document.addEventListener('click', function (e) {
      if (!d.contains(e.target)) d.classList.remove('is-open');
    });
  });

  // Menu mobile
  var mnav = document.querySelector('[data-mobile-nav]');
  var burger = document.querySelector('[data-menu-open]');
  if (mnav && burger) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    });
  }

  // Sous-menus du menu mobile
  document.querySelectorAll('[data-msub]').forEach(function (g) {
    var t = g.querySelector('[data-msub-toggle]');
    if (!t) return;
    t.addEventListener('click', function () {
      var open = g.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Tiroir panier
  var drawer = document.querySelector('[data-cart-drawer]');
  var backdrop = document.querySelector('[data-cart-backdrop]');
  function openCart(e) { if (e) e.preventDefault(); if (drawer) { drawer.classList.add('is-open'); backdrop.classList.add('is-open'); } }
  function closeCart() { if (drawer) { drawer.classList.remove('is-open'); backdrop.classList.remove('is-open'); } }
  document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.addEventListener('click', openCart); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-cart-close]')) closeCart(); });

  // Ajout au panier sans quitter la page
  var dzEn = (document.documentElement.lang || '').indexOf('en') === 0;
  function dzFlash(btn, text, ms) {
    if (!btn) return;
    if (!btn.dataset.label) btn.dataset.label = btn.textContent;
    btn.textContent = text;
    clearTimeout(btn._dzT);
    btn._dzT = setTimeout(function () { btn.textContent = btn.dataset.label; delete btn.dataset.label; }, ms || 2200);
  }
  function dzRefreshCart() {
    return fetch(window.location.pathname + window.location.search, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        var cur = document.querySelector('[data-cart-drawer]');
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; dzBindCart(cur); }
        var fc = doc.querySelector('.cart-count');
        document.querySelectorAll('.cart-count').forEach(function (c) { if (fc) c.textContent = fc.textContent; });
      });
  }
  function dzAddToCart(form, btn) {
    if (btn) btn.disabled = true;
    fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function () {
      if (btn) btn.disabled = false;
      dzFlash(btn, dzEn ? 'Added ✓' : 'Ajouté ✓');
      return dzRefreshCart();
    }).catch(function (err) {
      if (btn) btn.disabled = false;
      dzFlash(btn, (err && err.description) || (dzEn ? 'Error, try again' : 'Erreur, réessayez'), 3500);
    });
  }

  if (backdrop) backdrop.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  // Slider hero
  document.querySelectorAll('[data-slider]').forEach(function (s) {
    var slides = s.querySelectorAll('[data-slide]');
    var dots = s.querySelectorAll('[data-slide-dot]');
    if (slides.length < 2) return;
    var i = 0, timer;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      dots.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
    }
    function start() { timer = setInterval(function () { show(i + 1); }, parseInt(s.dataset.interval || '2000', 10)); }
    function reset() { clearInterval(timer); start(); }
    s.querySelectorAll('[data-slide-prev]').forEach(function (b) { b.addEventListener('click', function () { show(i - 1); reset(); }); });
    s.querySelectorAll('[data-slide-next]').forEach(function (b) { b.addEventListener('click', function () { show(i + 1); reset(); }); });
    dots.forEach(function (b, k) { b.addEventListener('click', function () { show(k); reset(); }); });
    show(0); start();
  });

  // Galerie produit : la photo change avec la variante / vignette
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.dataset.full || t.querySelector('img').src;
        main.srcset = '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  // Visionneuse plein écran
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var box = g.querySelector('[data-lightbox]');
    var boxImg = box && box.querySelector('[data-lightbox-img]');
    var trigger = g.querySelector('[data-lightbox-open]');
    if (!box || !boxImg || !trigger) return;
    var srcs = [];
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { if (t.dataset.full) srcs.push(t.dataset.full); });
    var i = 0;
    function paint() { boxImg.src = srcs[i] || boxImg.src; }
    function open() {
      var cur = g.querySelector('[data-gallery-main] img');
      if (!cur) return;
      var k = srcs.indexOf(cur.src);
      i = k > -1 ? k : 0;
      if (!srcs.length) { boxImg.src = cur.src; } else { paint(); }
      boxImg.alt = cur.alt || '';
      box.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() { box.hidden = true; document.body.style.overflow = ''; }
    function step(d) { if (!srcs.length) return; i = (i + d + srcs.length) % srcs.length; paint(); }
    trigger.addEventListener('click', open);
    trigger.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    box.querySelectorAll('[data-lightbox-close]').forEach(function (b) { b.addEventListener('click', close); });
    box.querySelectorAll('[data-lightbox-prev]').forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
    box.querySelectorAll('[data-lightbox-next]').forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
  });
   document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      dzAddToCart(form, form.querySelector('[data-add]') || form.querySelector('[type="submit"]'));
    });
    var select = form.querySelector('[name="id"]');
    form.querySelectorAll('[data-variant-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-group]');
        group.querySelectorAll('[data-variant-option]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var lbl = group.querySelector('[data-option-label]');
        if (lbl) lbl.textContent = btn.dataset.value;
        var groups = form.querySelectorAll('[data-option-group]');
        var chosen = [];
        groups.forEach(function (g) {
          if (g.hasAttribute('data-option-hidden')) { chosen.push(null); return; }
          var sel = g.querySelector('[data-variant-option].is-selected');
          chosen.push(sel ? sel.dataset.value : null);
        });
        var variants = JSON.parse(form.dataset.variants || '[]');
        var match = variants.find(function (v) {
          return chosen.every(function (val, k) { return val === null || v.options[k] === val; });
        });
        if (!match) return;
        if (select) select.value = match.id;
        groups.forEach(function (g, k) {
          if (!g.hasAttribute('data-option-hidden')) return;
          g.querySelectorAll('[data-variant-option]').forEach(function (b) {
            b.classList.toggle('is-selected', b.dataset.value === match.options[k]);
          });
        });
        var price = form.querySelector('[data-price]');
        if (price && match.price_formatted) price.textContent = match.price_formatted;
        var submit = form.querySelector('[data-add]');
        if (submit) {
          submit.disabled = !match.available;
           submit.textContent = match.available
            ? (form.dataset.addLabel || 'Ajouter au panier')
            : (form.dataset.soldLabel || 'Épuisé');
        }
        if (match.featured_image) {
          var gal = document.querySelector('[data-gallery]');
          var main = gal && gal.querySelector('[data-gallery-main] img');
          if (main && main.src !== match.featured_image) {
            main.style.transition = 'opacity .18s ease';
            main.style.opacity = '.35';
            main.src = match.featured_image;
            main.srcset = '';
            setTimeout(function () { main.style.opacity = '1'; }, 60);
          }
          if (gal) {
            gal.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
              t.classList.toggle('is-active', t.dataset.full === match.featured_image);
            });
          }
        }
      });
    });
  });
    // Pastilles de couleur sur les cartes produit : change la photo sans quitter la page
  function dzBindSwatches(root) {
  root.querySelectorAll('[data-card-swatches]').forEach(function (wrap) {
    var card = wrap.closest('.card');
    if (!card) return;
    var chips = wrap.querySelectorAll('.swatch');
    var media = card.querySelector('[data-card-media]');
    var img = media && media.querySelector('img');
    var baseHref = media ? media.getAttribute('href') : '';
    var cartId = card.querySelector('input[name="id"]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        if (media && chip.dataset.variant) media.setAttribute('href', baseHref + '?variant=' + chip.dataset.variant);
        if (cartId && chip.dataset.variant) cartId.value = chip.dataset.variant;
        if (img && chip.dataset.img && img.getAttribute('src') !== chip.dataset.img) {
          img.style.transition = 'opacity .18s ease';
          img.style.opacity = '.3';
          img.removeAttribute('srcset');
          img.src = chip.dataset.img;
          setTimeout(function () { img.style.opacity = '1'; }, 60);
        }
      });
    });
   });
  }
  dzBindSwatches(document);

  // Cartes produit : choisir la taille avant d'ajouter au panier
  function dzBindCardForms(root) {
  root.querySelectorAll('[data-card-form]').forEach(function (form) {
    var panel = form.querySelector('[data-card-sizes]');
    var open = form.querySelector('[data-card-open]');
    if (!panel || !open) return;
    var idInput = form.querySelector('input[name="id"]');
    var variants = [];
    try { variants = JSON.parse(form.dataset.variants || '[]'); } catch (err) { return; }
    var ci = parseInt(form.dataset.colorIndex, 10);
    var si = parseInt(form.dataset.sizeIndex, 10);
    var card = form.closest('.card');
    var buttons = panel.querySelectorAll('[data-size]');

    function activeColor() {
      var chip = card && card.querySelector('[data-card-swatches] .swatch.is-active');
      return chip ? chip.getAttribute('title') : null;
    }
    function match(size) {
      var color = activeColor();
      return variants.filter(function (v) {
        if (v.opts[si] !== size) return false;
        if (ci >= 0 && color && v.opts[ci] !== color) return false;
        return true;
      })[0];
    }
    function refresh() {
      buttons.forEach(function (b) {
        var m = match(b.dataset.size);
        b.disabled = !m || !m.a;
      });
    }
    open.addEventListener('click', function () {
      refresh();
      panel.hidden = false;
      open.hidden = true;
    });
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var m = match(b.dataset.size);
        if (!m) return;
      idInput.value = m.id;
        panel.hidden = true;
        open.hidden = false;
        dzAddToCart(form, open);
      });
    });
     if (card) {
      card.querySelectorAll('[data-card-swatches] .swatch').forEach(function (chip) {
        chip.addEventListener('click', function () { if (!panel.hidden) refresh(); });
      });
    }
  });
}
  dzBindCardForms(document);

  // Recommandations produit (API Shopify, rendu de section)
  document.querySelectorAll('[data-recos]').forEach(function (el) {
    function load(url, next) {
      fetch(url).then(function (r) {
        if (!r.ok) throw new Error('recos');
        return r.text();
      }).then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-recos]');
        if (fresh && fresh.querySelector('.card')) {
          el.innerHTML = fresh.innerHTML;
          dzBindSwatches(el);
          dzBindCardForms(el);
          return;
        }
        if (next) load(next, null);
      }).catch(function () {});
    }
    if (el.dataset.url) load(el.dataset.url, el.dataset.urlFallback || null);
  });
// Panier : quantité appliquée automatiquement
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function dzBindCart(root) {
  root.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    var line = parseInt(input.dataset.line, 10);
    var row = input.closest('[data-cart-line]');
    var box = input.closest('.qty');

    function apply(qty) {
      if (isNaN(qty) || qty < 0) return;
      if (row) row.classList.add('is-busy');
      fetch(cartRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        if (input.closest('[data-cart-drawer]') && typeof dzRefreshCart === 'function') { dzRefreshCart(); } else { window.location.reload(); }
      }).catch(function () {
        if (row) row.classList.remove('is-busy');
      });
    }
    input.addEventListener('change', function () { apply(parseInt(input.value, 10)); });
    if (box) {
      box.querySelectorAll('[data-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var next = (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qtyStep, 10);
          if (next < 0) return;
          input.value = next;
          apply(next);
        });
      });
    }
  });
  root.querySelectorAll('[data-cart-remove]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var line = a.closest('[data-cart-line]');
      var i = line && line.querySelector('[data-cart-qty]');
      if (!i) return;
      e.preventDefault();
      i.value = 0;
      i.dispatchEvent(new Event('change'));
    });
  });
  // Panier : changer la taille d'une ligne

  root.querySelectorAll('[data-cart-size]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var oldId = sel.dataset.current;
      var newId = sel.value;
      if (!oldId || !newId || oldId === newId) return;
      var qty = parseInt(sel.dataset.qty, 10) || 1;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var updates = {};
      updates[oldId] = 0;
      updates[newId] = qty;
      sel.disabled = true;
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.reload();
      }).catch(function () {
        sel.disabled = false;
        sel.value = oldId;
      });
    });
  });
   }
  dzBindCart(document);
});
